<div class="modal-content record-delete-modal">
  <div class="modal-header">
    @if (translatedLang === 'en') {
    <h1 class="modal-title pull-left" id="my-modal-title">
      {{ "REMOVE" | globalTranslate }} {{ this.fullName
      }}{{ "APOSTROPHE_S" | globalTranslate }}
      {{ this.title | globalTranslate }}
    </h1>
    } @if (translatedLang !== 'en') {
    <h1 class="modal-title pull-left" id="my-modal-title">
      {{ this.removeSpanish }} {{ this.title | globalTranslate }} de
      {{ this.fullName }}
    </h1>
    }
    <button
      type="button"
      class="btn-close d-flex ml-auto p-2"
      [attr.aria-label]="'CLOSE' | globalTranslate"
      (click)="onCancel()"
    >
      <img
        src="../../assets/images/⚛️ icons-close-circle-outline.svg"
        alt="close-icon"
      />
    </button>
  </div>
  @if (this.sectionId !== 'ASCLD') {
  <form [formGroup]="form">
    <div class="modal-body">
      <div>
        @if (this.sectionId !== 'HHAPL') {
        <p>{{ headingExt | globalTranslate | restoreindiv: fullName }}</p>
        } @if (this.sectionId !== 'HHAPL' && this.sectionId !== 'ICEMI' &&
        this.sectionId !== 'ICSEM' && this.sectionId !== 'ASLIQ' &&
        this.sectionId !== 'ASVEH' && this.sectionId !== 'ASPRP' &&
        this.sectionId !== 'ASBUR' && this.sectionId !=='ASLIF' &&
        this.sectionId !=='OTHRS' && this.sectionId !== 'ASCLD') {
        <div class="col-lg-8 col">
          <nh-field
            [attr.aria-required]="true"
            label="{{ labelExt | globalTranslate | restoreindiv: fullName }}"
            [isRow]="true"
            [mandatory]="true"
          >
            <nh-datepicker>
              <input
                type="text"
                name="{{ formCtrlName }}"
                class="form-control"
                [attr.aria-label]="
                  labelExt | globalTranslate | restoreindiv: fullName
                "
                (change)="isInvalidDate($event)"
                formControlName="{{ formCtrlName }}"
                bsDatepicker
                nh
                [minDate]="minimumDate"
                [maxDate]="today"
                [required]="true"
              />
            </nh-datepicker>
          </nh-field>
        </div>
        } @if (this.sectionId === 'HHAPL') {
        <p>
          {{ "RECORD_DELETE_STATIC_TEXT1" | globalTranslate }}
          {{ this.assistingPersonName }}{{ headingExt | globalTranslate }}
        </p>
        } @if (this.sectionId === 'HHAPL') {
        <div class="col-lg-8 col">
          <nh-field
            [attr.aria-required]="true"
            label="{{ 'WHEN_DID' | globalTranslate }} {{
              this.assistingPersonName
            }}{{ labelExt | globalTranslate }}"
            [isRow]="true"
            [mandatory]="true"
          >
            <nh-datepicker>
              <input
                type="text"
                name="{{ formCtrlName }}"
                class="form-control"
                [attr.aria-label]="
                  ('WHEN_DID' | globalTranslate) +
                  ' ' +
                  this.assistingPersonName +
                  ' ' +
                  (labelExt | globalTranslate)
                "
                (change)="isInvalidDate($event)"
                formControlName="{{ formCtrlName }}"
                bsDatepicker
                nh
                [minDate]="minimumDate"
                [maxDate]="today"
                [required]="true"
                [attr.aria-label]="labelExt | globalTranslate"
              />
            </nh-datepicker>
          </nh-field>
        </div>
        } @if (this.sectionId === 'ICSEM') {
        <div class="col-lg-8 col">
          <nh-field
            [attr.aria-required]="true"
            label="{{ labelExt | globalTranslate | restoreindiv: fullName }}"
            [isRow]="true"
            [mandatory]="true"
          >
            <nh-datepicker>
              <input
                type="text"
                name="{{ formCtrlName }}"
                class="form-control"
                [attr.aria-label]="
                  labelExt | globalTranslate | restoreindiv: fullName
                "
                (change)="isInvalidDate($event)"
                formControlName="{{ formCtrlName }}"
                bsDatepicker
                nh
                [minDate]="minimumDate"
                [maxDate]="today"
                [required]="true"
              />
            </nh-datepicker>
          </nh-field>
        </div>
        } @if (this.sectionId === 'ASLIQ' || this.sectionId === 'ASVEH' ||
        this.sectionId === 'ASPRP' || this.sectionId === 'ASBUR' ||
        this.sectionId ==='ASLIF' || this.sectionId ==='OTHRS') {
        <div class="col-lg-8 col">
          <nh-field
            [attr.aria-required]="true"
            label="{{ labelExt | globalTranslate | restoreindiv: fullName }}"
            [isRow]="true"
            [mandatory]="true"
          >
            <nh-datepicker>
              <input
                type="text"
                name="{{ formCtrlName }}"
                class="form-control"
                [attr.aria-label]="
                  labelExt | globalTranslate | restoreindiv: fullName
                "
                (change)="isInvalidDate($event)"
                formControlName="{{ formCtrlName }}"
                bsDatepicker
                nh
                [minDate]="minimumDate"
                [maxDate]="today"
                [required]="true"
              />
            </nh-datepicker>
          </nh-field>
        </div>
        } @if (this.sectionId === 'ICEMI') {
        <div>
          <div class="col-lg-8 col">
            <nh-field
              [attr.aria-required]="true"
              label="{{ 'RECORD_DELETE_STATIC_TEXT2' | globalTranslate }}"
              [isRow]="true"
              [mandatory]="true"
            >
              <nh-datepicker>
                <input
                  type="text"
                  name="employmentEndDate"
                  class="form-control"
                  [attr.aria-label]="
                    'RECORD_DELETE_STATIC_TEXT2' | globalTranslate
                  "
                  (change)="isInvalidDate($event)"
                  formControlName="employmentEndDate"
                  bsDatepicker
                  nh
                  [minDate]="minimumDate"
                  [maxDate]="today"
                  [required]="true"
                />
              </nh-datepicker>
            </nh-field>
          </div>
          <div class="col-lg-8 col">
            <nh-field
              [attr.aria-required]="true"
              label="{{ 'RECORD_DELETE_STATIC_TEXT3' | globalTranslate }} {{
                this.fullName
              }}{{ 'RECORD_DELETE_STATIC_TEXT4' | globalTranslate }}"
              [isRow]="true"
              [mandatory]="true"
            >
              <nh-datepicker>
                <input
                  type="text"
                  name="lastPaycheckDate"
                  class="form-control"
                  [attr.aria-label]="
                    ('RECORD_DELETE_STATIC_TEXT3' | globalTranslate) +
                    ' ' +
                    this.fullName +
                    ' ' +
                    ('RECORD_DELETE_STATIC_TEXT4' | globalTranslate)
                  "
                  (change)="isInvalidDate($event)"
                  formControlName="lastPaycheckDate"
                  bsDatepicker
                  nh
                  [minDate]="minimumDate"
                  [maxDate]="today"
                  [required]="this.sectionId === 'ICEMI'"
                />
              </nh-datepicker>
            </nh-field>
          </div>
          <div class="col-lg-8 col">
            <nh-field
              [attr.aria-required]="true"
              label="{{ 'RECORD_DELETE_STATIC_TEXT5' | globalTranslate }} {{
                this.fullName
              }}{{ 'RECORD_DELETE_STATIC_TEXT4' | globalTranslate }}"
              [isRow]="true"
              [mandatory]="true"
            >
              <nh-input-group prepend="$">
                <input
                  type="decimal"
                  maxlength="7"
                  class="form-control"
                  [attr.aria-label]="
                    ('RECORD_DELETE_STATIC_TEXT5' | globalTranslate) +
                    ' ' +
                    this.fullName +
                    ' ' +
                    ('RECORD_DELETE_STATIC_TEXT4' | globalTranslate)
                  "
                  name="lastPaycheckAmt"
                  formControlName="lastPaycheckAmt"
                  [required]="this.sectionId === 'ICEMI'"
                />
              </nh-input-group>
            </nh-field>
          </div>
        </div>
        }
      </div>
    </div>
    <div class="modal-footer" style="justify-content: flex-start">
      <div class="me-2 ml-2">
        @if (showConfirm) {
        <button
          type="button"
          id="dialog"
          [attr.disabled]="isDisabled"
          class="btn d-grid btn-secondary"
          (click)="onConfirm()"
        >
          {{ "SUBMIT" | globalTranslate }}
        </button>
        }
      </div>
      <div class="me-2 ml-2">
        @if (showDecline) {
        <button
          type="button"
          id="dialog"
          class="btn d-grid btn-link"
          (click)="onCancel()"
        >
          {{ declineButton | globalTranslate }}
        </button>
        }
      </div>
    </div>
  </form>
  } @if (this.sectionId === 'ASCLD') {
  <form [formGroup]="agreeTermsForm">
    <div class="modal-body">
      <div>
        <p>{{ headingExt | globalTranslate | restoreindiv: fullName }}</p>
        <div class="col-lg-8 col">
          <nh-field
            [attr.aria-required]="true"
            label="{{ labelExt | globalTranslate | restoreindiv: fullName }}"
            [isRow]="true"
            [mandatory]="true"
          >
            <nh-datepicker>
              <input
                type="text"
                name="{{ formCtrlName }}"
                class="form-control"
                [attr.aria-label]="
                  labelExt | globalTranslate | restoreindiv: fullName
                "
                (change)="isInvalidDate($event)"
                formControlName="{{ formCtrlName }}"
                bsDatepicker
                nh
                [minDate]="minimumDate"
                [maxDate]="today"
                [required]="true"
              />
            </nh-datepicker>
          </nh-field>
          <nh-checkbox
            name="agreeTerms"
            [control]="agreeTermsForm.controls['agreeTerms']"
            checkedValue="checked"
            tabindex="0"
            [mandatory]="true"
            >{{ "RECORD_DELETE_STATIC_TEXT6" | globalTranslate
            }}{{ this.fullName
            }}{{ "RECORD_DELETE_STATIC_TEXT7" | globalTranslate }}
          </nh-checkbox>
        </div>
      </div>
    </div>
    <div class="modal-footer" style="justify-content: flex-start">
      <div class="me-2 ml-2">
        @if (showConfirm) {
        <button
          type="button"
          id="dialog"
          [attr.disabled]="isDisabled"
          class="btn d-grid btn-secondary"
          (click)="onConfirm()"
        >
          {{ "SUBMIT" | globalTranslate }}
        </button>
        }
      </div>
      <div class="me-2 ml-2">
        @if (showDecline) {
        <button
          type="button"
          id="dialog"
          class="btn d-grid btn-link"
          (click)="onCancel()"
        >
          {{ declineButton | globalTranslate }}
        </button>
        }
      </div>
    </div>
  </form>
  }
</div>